export const myPageBundle = {
  eyebrow: { ko: "계정 설정", en: "Account Settings", es: "Configuración de la cuenta" },
  title: { ko: "마이페이지", en: "My Page", es: "Mi página" },
  description: {
    ko: "계정 보안을 위해 비밀번호를 안전하게 관리하세요.",
    en: "Manage your password securely to protect your account.",
    es: "Administre su contraseña de forma segura para proteger su cuenta."
  },
  profile: {
    title: { ko: "내 프로필", en: "My Profile", es: "Mi perfil" },
    description: {
      ko: "계정에 등록된 기본 정보를 확인하고 수정할 수 있습니다.",
      en: "View and edit your basic account information.",
      es: "Consulte y edite la información básica de su cuenta."
    },
    name: { ko: "이름", en: "Name", es: "Nombre" },
    phone: { ko: "전화번호", en: "Phone", es: "Teléfono" },
    email: { ko: "이메일", en: "Email", es: "Correo electrónico" },
    empty: { ko: "등록되지 않음", en: "Not registered", es: "No registrado" },
    edit: { ko: "수정", en: "Edit", es: "Editar" },
    save: { ko: "저장", en: "Save", es: "Guardar" },
    cancel: { ko: "취소", en: "Cancel", es: "Cancelar" },
    success: {
      ko: "프로필 정보가 수정되었습니다.",
      en: "Your profile has been updated.",
      es: "Su perfil ha sido actualizado."
    },
    failure: {
      ko: "프로필 정보를 불러오지 못했습니다.",
      en: "Failed to load your profile.",
      es: "No se pudo cargar su perfil."
    }
  },
  password: {
    title: { ko: "비밀번호 변경", en: "Change Password", es: "Cambiar contraseña" },
    description: {
      ko: "본인 인증 후 계정 비밀번호를 변경할 수 있습니다.",
      en: "Change your account password after verification.",
      es: "Cambie la contraseña de su cuenta después de la verificación."
    },
    open: { ko: "변경", en: "Change", es: "Cambiar" },
    verifyTitle: {
      ko: "비밀번호 인증",
      en: "Password Verification",
      es: "Verificación de contraseña"
    },
    verifyDescription: {
      ko: "본인 확인을 위해 현재 비밀번호를 입력해 주세요.",
      en: "Enter your current password to verify your identity.",
      es: "Introduzca su contraseña actual para verificar su identidad."
    },
    verifySubmit: { ko: "인증", en: "Verify", es: "Verificar" },
    verifying: { ko: "인증 중...", en: "Verifying...", es: "Verificando..." },
    current: { ko: "현재 비밀번호", en: "Current Password", es: "Contraseña actual" },
    new: { ko: "새 비밀번호", en: "New Password", es: "Nueva contraseña" },
    confirm: {
      ko: "새 비밀번호 확인",
      en: "Confirm New Password",
      es: "Confirmar nueva contraseña"
    },
    hint: {
      ko: "8자 이상 20자 이하로 영문, 숫자, 특수문자를 각각 1자 이상 포함해 주세요.",
      en: "Use 8–20 characters with at least one letter, number, and special character.",
      es: "Use entre 8 y 20 caracteres e incluya al menos una letra, un número y un carácter especial."
    },
    submit: { ko: "비밀번호 변경", en: "Change Password", es: "Cambiar contraseña" },
    submitting: { ko: "변경 중...", en: "Changing...", es: "Cambiando..." },
    mismatch: {
      ko: "새 비밀번호가 일치하지 않습니다.",
      en: "The new passwords do not match.",
      es: "Las nuevas contraseñas no coinciden."
    },
    success: {
      ko: "비밀번호가 변경되었습니다.",
      en: "Your password has been changed.",
      es: "Su contraseña ha sido cambiada."
    },
    failure: {
      ko: "비밀번호 변경에 실패했습니다.",
      en: "Failed to change the password.",
      es: "No se pudo cambiar la contraseña."
    }
  }
}
